module.exports = __webpack_public_path__ + "img/img_aiplan_04.016c61fd.png";